import React from 'react';

export const FormattedOpeningHours = ({ hours }) => {
  if (!hours) {
    return <div>Opening hours: Not available</div>;
  }

  // Remove the "OPEN: " prefix if it exists, case-insensitively.
  const cleanedHours = hours.replace(/^open: /i, '');

  // Split by comma, then trim whitespace from each part, and filter out any empty strings
  // that might result from a trailing comma.
  const parts = cleanedHours
    .split(',')
    .map(part => part.trim())
    .filter(part => part.length > 0);

  // If after all that, we have no parts, return a default message.
  if (parts.length === 0) {
    return <div>Opening hours: Not available</div>;
  }

  return (
    <div className="hours tag">
      <div className="line">
        <span className="label">Opening hours:</span>
        <span>{parts[0]}</span>
      </div>
      {parts.slice(1).map((part, index) => (
        <div className="line" key={index + 1}>
          <span className="label label-placeholder" style={{display: 'none'}}/>
          <span>{part}</span>
        </div>
      ))}
    </div>
  );
}; 